import { useState } from 'react';
import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { faqs, trustPoints } from '@/mocks/home';

export default function TrustSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="trust" className="scroll-mt-header w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-8">
        <Reveal>
          <SectionHeading
            index="04"
            eyebrow="Trust & FAQ"
            title="内容怎么来的，一次说清楚"
            desc="我们只做公开信息的聚合与时间线梳理，不对任何事件作定性判断。下面这些问题基本覆盖了使用者最关心的部分。"
          />
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-1">
              {trustPoints.map((point, index) => (
                <Reveal key={point.title} delay={index * 60}>
                  <div className="flex h-full gap-4 rounded-lg border border-background-200/70 bg-background-50 p-5">
                    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                      <i className={`${point.icon} flex h-5 w-5 items-center justify-center text-lg`} />
                    </span>
                    <div>
                      <h3 className="font-heading text-[15px] font-bold text-foreground-950">
                        {point.title}
                      </h3>
                      <p className="mt-2 text-[13px] leading-6 text-foreground-600">{point.desc}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7">
            <Reveal delay={80}>
              <div className="rounded-lg border border-background-200/70 bg-background-50 p-5 md:p-7">
                <h3 className="font-heading text-lg font-bold text-foreground-950">常见问题</h3>
                <div className="mt-5 flex flex-col divide-y divide-background-200/70">
                  {faqs.map((faq, index) => {
                    const isOpen = openIndex === index;
                    return (
                      <div key={faq.q} className="py-4 first:pt-0 last:pb-0">
                        <h4 className="m-0">
                          <button
                            type="button"
                            aria-expanded={isOpen}
                            onClick={() => setOpenIndex(isOpen ? -1 : index)}
                            className="flex w-full items-center justify-between gap-4 text-left"
                          >
                            <span
                              className={`text-sm font-semibold transition-colors md:text-[15px] ${
                                isOpen ? 'text-primary-700' : 'text-foreground-900'
                              }`}
                            >
                              {faq.q}
                            </span>
                            <span
                              className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                                isOpen
                                  ? 'bg-primary-500 text-background-50 dark:text-foreground-950'
                                  : 'bg-background-100 text-foreground-700'
                              }`}
                            >
                              <i
                                className={`${isOpen ? 'ri-subtract-line' : 'ri-add-line'} flex h-4 w-4 items-center justify-center text-base`}
                              />
                            </span>
                          </button>
                        </h4>
                        {isOpen ? (
                          <p className="mt-3 max-w-2xl text-[13px] leading-7 text-foreground-600">
                            {faq.a}
                          </p>
                        ) : null}
                      </div>
                    );
                  })}
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}